module.exports = __webpack_public_path__ + "img/arrow_full_right.bddd24f3.svg";